import { useCallback, useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { loadPersons } from '@/api/query/loadPersons';
import { useGuestAuth } from '@/common/contexts/GuestAuthContext';
import { useLanguage } from '@/common/hooks/useLanguageData';
import { buildPersonListQuery } from '@/common/utils/personListQuery';
import { DISCOVER_PAGE_SIZE } from '../utils/discover.constants';

export const useDiscoverPersons = () => {
	const { isLoggedIn } = useGuestAuth();
	const { lang } = useLanguage();
	const [persons, setPersons] = useState([]);
	const [isInitialFetchDone, setIsInitialFetchDone] = useState(false);

	const buildQuery = useCallback(
		() => buildPersonListQuery({
			skip: 0,
			limit: DISCOVER_PAGE_SIZE,
			language: lang,
		}),
		[lang],
	);

	const loadPeopleMutation = useMutation({
		mutationFn: (payload) => loadPersons(payload),
		onSuccess: ({ data }) => {
			setPersons(data ?? []);
			setIsInitialFetchDone(true);
		},
		onError: () => {
			setPersons([]);
			setIsInitialFetchDone(true);
		},
	});

	useEffect(() => {
		setPersons([]);
		setIsInitialFetchDone(false);
		loadPeopleMutation.mutate(buildQuery());
	}, [lang, isLoggedIn]);

	return {
		persons,
		isLoading: !isInitialFetchDone,
	};
};
